import React from 'react';

import { UiKit } from 'components';
import { useRequestReasonConfig } from '../../context';
import { ReactComponent as PlusIcon } from 'assets/ss-icons/plus.svg';

export default function AddButton() {
  const { data, isDisabled, isProcessing, onChange } = useRequestReasonConfig();

  const onAddSubReason = () => {
    let subReasonsData = data.sub_reasons_data;

    if (!data.sub_reasons_data) {
      subReasonsData = {
        allow_multiple: false,
        sub_reasons: ['', '']
      };
    } else {
      subReasonsData = {
        ...subReasonsData,
        sub_reasons: [...subReasonsData.sub_reasons, '']
      };
    }

    onChange(
      { allows_sub_reasons: true, sub_reasons_data: subReasonsData },
      { runValidation: false }
    );
  };

  return (
    <UiKit.Button
      variant="ghost"
      onClick={onAddSubReason}
      disabled={isProcessing || isDisabled}
      className="mr-auto"
    >
      <PlusIcon />
      Add Sub Reason
    </UiKit.Button>
  );
}
